/**
 * Validate if roles and permissions exists for the given view target.
 * @param {Array} roles the roles.
 * @param {String} action the action.
 * @param {String} target the action target.
 * @return {Boolean} result of the validation.
 */
export function checkRolePermissions(
  roles: Array,
  action: String,
  target: String
) {
  let hasPermissions = false;
  roles.forEach((role) => {
    if (role.permissions) {
      role.permissions.forEach((permission) => {
        if (permission.action === action && permission.target === target) {
          hasPermissions = true;
        }
      });
    }
  });
  return hasPermissions;
}
